/**
 * @voltxampere/ui — Single-turn trim potentiometer (Sprint 51-1 polish)
 *
 * Bourns 3296P-style single-turn trim pot — quick-adjust counterpart
 * to the 10-turn precision variant (Sprint 50-8). Used for routine
 * calibration where ±5% precision is enough.
 *
 * Engine zero-diff invariant honored — schemaType `potentiometer`.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { resistor } from "../resistor.js";
export const potTrimSingleTurn = {
    id: "trim-pot-1t",
    nameTr: "Trim Potansiyometre (tek-tur, hızlı ayar)",
    nameEn: "Trim Potentiometer (single-turn, quick-adjust)",
    shortcut: "P",
    category: "passive",
    viewBox: resistor.viewBox,
    terminals: resistor.terminals,
    defaultLabel: "RV",
    defaultValue: "10kΩ",
    schemaType: "potentiometer",
    defaultParams: {
        resistance: 10000,
        wiperPosition: 0.5,
        turnsPerRotation: 1,
        package: "Bourns 3296P",
        tolerancePercent: 20,
    },
    renderSVG: () => resistor.renderSVG(),
};
//# sourceMappingURL=pot-trim-single-turn.js.map